import React, { Component } from 'react';
import './Question.scss';

const Question = ({ questionText }) => {
    return (
        <section className='question' key={questionText}>
            <p 
                className='question__text'
                dangerouslySetInnerHTML={{ __html: questionText }}
            />
        </section>
    );
};

export default Question;



// WEBPACK FOOTER //
// ./application/components/Question/Question.jsx